import type Store from '~/types/Store';

import api from '~/services/api';
import { StoreStatusName, type StoreName, type jsonStore } from '~/types/Store';
import { decamelizeKeys } from '~/utils/humps';
import { stringifyUrlSearchParams } from '~/utils/url';

type FetchStoresParams = {
  results?: number;
  status?: StoreStatusName[];
};

type GetStoresResponse = {
  count: number;
  next: null | string;
  previous: null | string;
  results: jsonStore[];
};

export const getStoresQueryKey = () => ['fetchStores'] as const;

export const fetchStores = ({
  results = 50,
  status = [StoreStatusName.Connected],
}: FetchStoresParams = {}) =>
  api.get<GetStoresResponse>('ui/stores', {
    params: {
      results,
      status,
    },
    paramsSerializer: (params) => stringifyUrlSearchParams(params, { arrayFormat: 'repeat' }),
  });

export const disconnectStore = (storeName: StoreName, objectId: string) =>
  api.post('ui/stores/disconnect', {
    object_id: objectId,
    store_name: storeName,
  });

export const editStore = (store: Store) =>
  api.put(`ui/stores/${store.objectId}`, {
    ...decamelizeKeys(store),
  });
